{
  "angular": {
    "guides": {
      "datetime": [
        "adapter",
        "config",
        "date",
        "native",
        "temporal"
      ],
      "gettingStarted": [
        "angular.json",
        "import",
        "install",
        "ng add",
        "npm",
        "schematics",
        "setup",
        "yarn"
      ],
      "i18n": [
        "i18n",
        "internationalization",
        "localization",
        "language",
        "lang",
        "translation",
        "ssr"
      ],
      "layout": [
        "expanded",
        "flex",
        "grid",
        "orientation",
        "spacing"
      ],
      "theming": [
        "a11y",
        "accessibility",
        "alpha",
        "animation",
        "background",
        "bold",
        "brand",
        "characters",
        "color",
        "css",
        "cursor",
        "dark",
        "description",
        "design",
        "error",
        "focus",
        "font",
        "icon-list",
        "inverted",
        "lean",
        "li",
        "light",
        "light",
        "list",
        "negative",
        "off-brand",
        "ol",
        "outline",
        "responsive",
        "roman",
        "safety",
        "sass",
        "screenreader",
        "scrollbar",
        "scss",
        "shadow",
        "step-list",
        "style",
        "success",
        "text",
        "text",
        "theme",
        "token",
        "typography",
        "ul",
        "warning"
      ]
    },
    "components": {
      "accordion": [
        "sbb-accordion"
      ],
      "actionGroup": [
        "sbb-action-group"
      ],
      "alert": [
        "sbb-alert",
        "sbb-alert-group"
      ],
      "autocomplete": [
        "sbbAutocomplete",
        "sbb-autocomplete",
        "sbb-autocomplete-button",
        "sbb-autocomplete-row",
        "form"
      ],
      "badge": [
        "sbb-badge",
        "sbb-badge-position"
      ],
      "breadcrumb": [
        "sbb-breadcrumb",
        "sbb-breadcrumb-group"
      ],
      "button": [
        "sbb-accent-button",
        "sbb-accent-button-link",
        "sbb-accent-button-static",
        "sbb-button",
        "sbb-button-link",
        "sbb-button-static",
        "sbb-mini-button",
        "sbb-mini-button-group",
        "sbb-mini-button-link",
        "sbb-secondary-button",
        "sbb-secondary-button-link",
        "sbb-secondary-button-static",
        "sbb-transparent-button",
        "sbb-transparent-button-link",
        "sbb-transparent-button-static",
        "form"
      ],
      "calendar": [
        "sbb-calendar",
        "sbb-calendar-day",
        "sbb-calendar-month",
        "sbb-calendar-weekday",
        "sbb-calendar-weeknumber",
        "sbb-calendar-year",
        "form"
      ],
      "card": [
        "sbb-card",
        "sbb-card-badge",
        "sbb-card-button",
        "sbb-card-link"
      ],
      "carousel": [
        "sbb-carousel",
        "sbb-carousel-item",
        "sbb-carousel-list"
      ],
      "checkbox": [
        "sbb-checkbox",
        "form"
      ],
      "checkboxGroup": [
        "sbb-checkbox-group"
      ],
      "checkboxPanel": [
        "sbb-checkbox-panel",
        "form"
      ],
      "chip": [
        "sbb-chip",
        "sbb-chip-group",
        "form"
      ],
      "chipLabel": [
        "sbb-chip-label"
      ],
      "clock": [
        "sbb-clock"
      ],
      "container": [
        "sbb-container",
        "sbb-sticky-bar"
      ],
      "core": [
        "sbb-focus-initial"
      ],
      "dateInput": [
        "sbb-date-input",
        "form"
      ],
      "datepicker": [
        "sbb-datepicker",
        "sbb-datepicker-next-day",
        "sbb-datepicker-previous-day",
        "sbb-datepicker-toggle"
      ],
      "dialog": [
        "sbb-dialog",
        "sbbDialog",
        "sbb-dialog-actions",
        "sbb-dialog-close",
        "sbb-dialog-close-button",
        "sbb-dialog-content",
        "sbb-dialog-title"
      ],
      "divider": [
        "sbb-divider"
      ],
      "download": [
        "sbb-download",
        "sbb-download-info"
      ],
      "expansionPanel": [
        "sbb-expansion-panel",
        "sbbExpansionPanelContent",
        "sbb-expansion-panel-content",
        "sbb-expansion-panel-header"
      ],
      "fileSelector": [
        "sbb-file-selector",
        "sbb-file-selector-dropzone",
        "form"
      ],
      "flipCard": [
        "sbb-flip-card",
        "sbb-flip-card-details",
        "sbb-flip-card-summary"
      ],
      "footer": [
        "sbb-footer"
      ],
      "formField": [
        "sbb-error",
        "sbb-form-field",
        "sbb-form-field-clear",
        "sbb-form-field-text-counter",
        "sbb-hint"
      ],
      "header": [
        "sbb-header",
        "sbb-header-button",
        "sbb-header-environment",
        "sbb-header-link",
        "sbb-header-scroll-origin"
      ],
      "icon": [
        "sbb-icon"
      ],
      "iconSidebar": [
        "sbb-icon-sidebar",
        "sbb-icon-sidebar-button",
        "sbb-icon-sidebar-container",
        "sbb-icon-sidebar-content",
        "sbb-icon-sidebar-link"
      ],
      "image": [
        "sbb-image"
      ],
      "journeyHeader": [
        "sbb-journey-header"
      ],
      "leadContainer": [
        "sbb-lead-container"
      ],
      "link": [
        "sbb-block-link",
        "sbb-block-link-button",
        "sbb-block-link-static",
        "sbb-link",
        "sbb-link-button",
        "sbb-link-static"
      ],
      "linkList": [
        "sbb-link-list"
      ],
      "linkListAnchor": [
        "sbb-link-list-anchor"
      ],
      "loadingIndicator": [
        "sbb-loading-indicator"
      ],
      "loadingIndicatorCircle": [
        "sbb-loading-indicator-circle"
      ],
      "logo": [
        "sbb-logo",
        "sbb-logo-anniversary",
        "sbb-logo-cargo",
        "sbb-logo-cargo-international",
        "sbb-logo-elvetino"
      ],
      "mapContainer": [
        "sbb-map-container"
      ],
      "menu": [
        "sbbMenu",
        "sbb-menu",
        "sbb-menu-button",
        "sbb-menu-link"
      ],
      "message": [
        "sbb-message"
      ],
      "miniCalendar": [
        "sbbMiniCalendarDay",
        "sbb-mini-calendar",
        "sbb-mini-calendar-day",
        "sbb-mini-calendar-month"
      ],
      "navigation": [
        "sbbNavigation",
        "sbb-navigation",
        "sbb-navigation-button",
        "sbb-navigation-close",
        "sbb-navigation-link",
        "sbb-navigation-list",
        "sbb-navigation-marker",
        "sbbNavigationSection",
        "sbb-navigation-section",
        "sbb-navigation-section-close"
      ],
      "notification": [
        "sbb-notification"
      ],
      "option": [
        "sbb-optgroup",
        "sbb-option",
        "sbb-option-hint"
      ],
      "overlay": [
        "sbb-overlay-close",
        "sbb-overlay",
        "sbbOverlay"
      ],
      "paginator": [
        "sbb-compact-paginator",
        "sbb-paginator"
      ],
      "pearlChain": [
        "sbb-pearl-chain",
        "sbb-pearl-chain-node"
      ],
      "popover": [
        "sbbPopover",
        "sbb-popover",
        "sbb-popover-close",
        "sbb-popover-close-button"
      ],
      "radioButton": [
        "sbb-radio-button",
        "form"
      ],
      "radioButtonGroup": [
        "sbb-radio-button-group"
      ],
      "radioButtonPanel": [
        "sbb-radio-button-panel",
        "form"
      ],
      "select": [
        "sbb-select",
        "form"
      ],
      "selectionActionPanel": [
        "sbb-selection-action-panel"
      ],
      "selectionExpansionPanel": [
        "sbb-selection-expansion-panel"
      ],
      "sidebar": [
        "sbb-sidebar",
        "sbb-sidebar-close-button",
        "sbb-sidebar-container",
        "sbb-sidebar-content",
        "sbb-sidebar-title"
      ],
      "signet": [
        "sbb-signet"
      ],
      "skiplinkList": [
        "sbb-skiplink-list"
      ],
      "slider": [
        "sbb-slider",
        "form"
      ],
      "status": [
        "sbb-status"
      ],
      "stepper": [
        "sbbStepContent",
        "sbb-step",
        "sbb-step-label",
        "sbb-stepper",
        "sbb-stepper-next",
        "sbb-stepper-previous"
      ],
      "table": [
        "sbb-sort-header",
        "sbbSort",
        "sbbSortActive",
        "sbbSortStart",
        "sbbSortDirection",
        "sbbSortDisabled",
        "sbbSortDisableClear",
        "sbbCellDef",
        "sbbHeaderCellDef",
        "sbbFooterCellDef",
        "sbbColumnDef",
        "sbb-header-cell",
        "sbb-footer-cell",
        "sbb-cell",
        "sbbHeaderRowDef",
        "sbbFooterRowDef",
        "sbbRowDef",
        "sbb-header-row",
        "sbb-footer-row",
        "sbb-row",
        "sbb-table",
        "sbb-text-column",
        "sbb-table-wrapper"
      ],
      "tabs": [
        "sbbTabContent",
        "sbb-tab",
        "sbb-tab-group",
        "sbb-tab-label",
        "sbb-tab-nav-bar"
      ],
      "tag": [
        "sbb-tag",
        "sbb-tag-group",
        "form"
      ],
      "teaser": [
        "sbb-teaser",
        "sbb-teaser-static"
      ],
      "teaserHero": [
        "sbb-teaser-hero"
      ],
      "teaserPanel": [
        "sbb-teaser-panel"
      ],
      "teaserProduct": [
        "sbb-teaser-product",
        "sbb-teaser-product-static"
      ],
      "timeInput": [
        "sbb-time-input",
        "form"
      ],
      "timetableForm": [
        "sbb-timetable-form",
        "sbb-timetable-form-details",
        "sbb-timetable-form-field",
        "sbb-timetable-form-swap-button"
      ],
      "timetableOccupancy": [
        "sbb-timetable-occupancy"
      ],
      "timetableOccupancyIcon": [
        "sbb-timetable-occupancy-icon"
      ],
      "title": [
        "sbb-title"
      ],
      "toast": [
        "sbb-toast-close",
        "sbb-toast"
      ],
      "toggle": [
        "sbb-toggle",
        "sbb-toggle-option",
        "form"
      ],
      "toggleCheck": [
        "sbb-toggle-check",
        "form"
      ],
      "tooltip": [
        "sbb-tooltip",
        "sbbTooltip",
        "sbb-tooltip-open-delay",
        "sbb-tooltip-close-delay",
        "sbb-tooltip-position"
      ],
      "train": [
        "sbb-train",
        "sbb-train-blocked-passage",
        "sbb-train-formation",
        "sbb-train-wagon",
        "sbb-train-wagon-button",
        "sbb-train-wagon-link"
      ],
      "visualCheckbox": [
        "sbb-visual-checkbox"
      ]
    }
  },
  "angularExperimental": {
    "guides": {
      "gettingStarted": [
        "angular.json",
        "import",
        "install",
        "ng add",
        "npm",
        "schematics",
        "setup",
        "yarn"
      ]
    },
    "components": {
      "autocompleteGrid": [
        "sbb-autocomplete-grid",
        "sbb-autocomplete-grid-button",
        "sbb-autocomplete-grid-cell",
        "sbb-autocomplete-grid-optgroup",
        "sbb-autocomplete-grid-option",
        "sbb-autocomplete-grid-row",
        "form"
      ],
      "easterEgg": [
        "sbbEasterEgg",
        "sbb-easter-egg"
      ],
      "journeySummary": [
        "sbb-journey-summary"
      ],
      "pearlChainLegacy": [
        "sbb-pearl-chain-legacy"
      ],
      "pearlChainTime": [
        "sbb-pearl-chain-time"
      ],
      "pearlChainVertical": [
        "sbb-pearl-chain-vertical"
      ],
      "pearlChainVerticalItem": [
        "sbb-pearl-chain-vertical-item"
      ],
      "seatReservation": [
        "sbb-seat-reservation",
        "sbb-seat-reservation-area",
        "sbb-seat-reservation-graphic",
        "sbb-seat-reservation-navigation-coach",
        "sbb-seat-reservation-navigation-services",
        "sbb-seat-reservation-place-control",
        "sbb-seat-reservation-scoped"
      ],
      "timetableDuration": [
        "sbb-timetable-duration"
      ],
      "timetableRow": [
        "sbb-timetable-row"
      ]
    }
  }
}